import { atomWithReset } from 'jotai/utils';
import { domain } from 'modules/data';

export const updateNetSuiteBillDataState = atomWithReset<((request: domain.NetSuiteBillRequest) => void) | null>(null);
